class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.activeFilter = "all";
  }
  connectedCallback() {
    this.render();
    this.addEventListeners();
  }
  render() {
    setTimeout(() => {
      const filters = /* @__PURE__ */ new Set();
      document.querySelectorAll(".product-card").forEach((card) => {
        if (card.dataset.tags) {
          card.dataset.tags.split(",").forEach((tag) => {
            tag = tag.trim();
            if (tag.startsWith("filter-")) filters.add(tag);
          });
        }
      });
      this.innerHTML = `
        <div class="flex gap-2 justify-start mb-12 overflow-auto px-0 lg:px-12 lg:pl-0">
          <button class="filter-btn active bg-white text-black font-medium px-6 py-2 rounded-full leading-[100%] cursor-pointer transition max-h-[38px]" data-filter="all">All</button>
          ${[...filters].map((tag) => `
            <button class="filter-btn border border-solid button-hover gradient-heading px-6 py-2 leading-[100%] rounded-full transition cursor-pointer max-h-[38px]" data-filter="${tag}">${tag.replace("filter-", "")}</button>
          `).join("")}
        </div>
      `;
      this.addEventListeners();
    }, 100);
  }
  addEventListeners() {
    this.querySelectorAll(".filter-btn").forEach((button) => {
      button.addEventListener("click", (event) => {
        this.filterProducts(event.currentTarget);
      });
    });
  }
  filterProducts(activeButton) {
    this.querySelectorAll(".filter-btn").forEach((btn) => {
      btn.classList.remove("active", "bg-white", "text-black");
      btn.classList.add("border", "border-solid", "button-hover", "gradient-heading");
    });
    activeButton.classList.add("active", "bg-white", "text-black");
    activeButton.classList.remove("border", "border-solid", "button-hover", "gradient-heading");
    const filter = activeButton.dataset.filter;
    document.querySelectorAll(".product-card").forEach((card) => {
      const cardFilters = (card.dataset.tags || "").split(",").map((tag) => tag.trim());
      if (filter === "all" || cardFilters.includes(filter)) {
        card.classList.remove("hidden");
      } else {
        card.classList.add("hidden");
      }
    });
  }
}
customElements.define("collection-filters", CollectionFilters);
